import React from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ContentWrapper, TitleContainer } from "../../../Admin/Administration/Staff/style";
import Breadcrumb from "../../../Common/PageElements/Breadcrumb";
import { PageTitle } from "../../../Common/style";
import ContractInfo from "../ContractInfo";
import withVendorDashboard from "../../HOC/withVendorDashboard";
import vendorsAPI from "../../../../redux/api/vendorsAPI";
import {
  MainText,
  MainTitle,
  CardWrapper,
  Pad,
  FileBoard,
  AwaitContract,
  CuteGrid,
  FileCard,
  FileText,
  InterestExpressedPane,
} from "../../Procurement/style";
import { ReactComponent as FolderIcon } from "../../../../assets/folder.svg";
import { ReactComponent as CheckIcon } from "../../../../assets/check_mark.svg";
import { ReactComponent as PendingCheckIcon } from "../../../../assets/pending_icon.svg";
import procurementAPI from "../../../../redux/api/procurementAPI";
import moment from "moment";

const LetterOfAcceptance = () => {
  const { contractId } = useParams();
  const { data: contractInfo } = useQuery(["contractInfo", contractId], vendorsAPI.getVendorContractById);
  const procurementId = contractInfo?.procurementPlan?.id;
  const { data: documents = [] } = useQuery(
    ["exchangedDocuments", contractInfo?.procurementPlan?.id],
    procurementAPI.getExchangedDocuments
  );

  const { data: letter = [] } = useQuery(["getIntentLetter", procurementId], vendorsAPI.getVendorLetterOfIntent);
  const datePublished = moment(letter[0]?.createdAt).format("DD/MM/YYYY");
  const deadline = moment(letter[0]?.deadline).format("DD/MM/YYYY");

  const BreadcrumbLinks = [
    { url: "/vendor/contracts", title: "Contract", forwardSlash: true },
    { url: "/vendor/contracts", title: " Details", forwardSlash: true },
    { url: "/vendor/contracts", title: " Letter of Acceptance", forwardSlash: false },
  ];

  return (
    <div>
      <ContentWrapper>
        <TitleContainer>
          <div>
            <PageTitle>{contractInfo?.procurementPlan?.packageNumber}</PageTitle>
            <Breadcrumb values={BreadcrumbLinks} />
          </div>
        </TitleContainer>

        <InterestExpressedPane>
          <CuteGrid>
            <div>
              <MainText color="#212B36" fw="bold" fontSize="14px">
                Letter of Intent acknowledged
              </MainText>
              <MainText color="#212B36" mt="10px" fontSize="14px">
                Please wait while we prepare contract document
              </MainText>
            </div>
            <div>
              <CheckIcon />
            </div>
          </CuteGrid>
        </InterestExpressedPane>

        <CardWrapper>
          <Pad>
            <ContractInfo id={procurementId} publishDate={datePublished} deadline={deadline} />
            <MainTitle mt="40px">Documents</MainTitle>
            <MainText mt="15px" fontSize="14px">
              List of all documents exchanged
            </MainText>
          </Pad>
          {documents.length ? (
            <FileBoard>
              <CuteGrid start>
                {documents.map((doc) => (
                  <div key={doc.id}>
                    <FileCard>
                      <FolderIcon />
                      <FileText mt="15px" color="#2AA96D" fontSize="13px">
                        {doc.count} files
                      </FileText>
                    </FileCard>
                    <FileText mt="20px" fontSize="14px" wd="77%">
                      {doc.title}
                    </FileText>
                  </div>
                ))}
              </CuteGrid>
            </FileBoard>
          ) : (
            <Pad>
              {" "}
              <MainText mt="10px">No documents yet</MainText>{" "}
            </Pad>
          )}
        </CardWrapper>

        <CardWrapper mt="20px">
          <Pad>
            <MainTitle>Awaiting contract document</MainTitle>
          </Pad>
          <AwaitContract>
            <Pad>
              <MainTitle>Contract Document</MainTitle>
              <CuteGrid>
                <MainText mt="8px">Please wait while we prepare your contract document.....</MainText>
                <PendingCheckIcon />
              </CuteGrid>
            </Pad>
          </AwaitContract>
        </CardWrapper>
      </ContentWrapper>
    </div>
  );
};

export default withVendorDashboard(LetterOfAcceptance);
